import { useLocation } from "react-router-dom";

/**
 * Phase 2Z.ab - Super Admin support/testing pack.
 *
 * Thin top-of-page ribbon shown on every /app/admin/* route so the founder
 * cannot mistake the isolated preview pod (where Acme demo, test trials and
 * @nextrota-e2e seed data live) for the live production database. Pure
 * frontend detection - no backend env exposure. Detection rule:
 *   - hostname includes "nextrota.com" -> LIVE / PRODUCTION (emerald)
 *   - everything else                  -> PREVIEW / TEST DATABASE (amber)
 *
 * Designed to be visually loud enough to act as a guard-rail without
 * pushing the admin layout around: 28px tall, sticky at the very top,
 * z-index above the impersonation banner so a super admin who is
 * already impersonating still sees the environment context.
 */
export default function EnvRibbon() {
  const location = useLocation();
  // Only show on super-admin pages.
  if (!location.pathname.startsWith("/app/admin")) return null;

  const host = typeof window !== "undefined" ? window.location.hostname : "";
  const isLive = host.includes("nextrota.com");

  const label = isLive ? "LIVE / PRODUCTION" : "PREVIEW / TEST DATABASE";
  const sub = isLive
    ? "Changes here affect paying customers. Proceed with care."
    : "Test data only. Safe to experiment.";

  const colour = isLive
    ? "bg-emerald-700 text-white"
    : "bg-amber-500 text-[#0B1A36]";

  return (
    <div
      data-testid="env-ribbon"
      data-env={isLive ? "live" : "preview"}
      className={`${colour} text-[11px] uppercase tracking-widest font-semibold px-4 py-1.5 flex items-center justify-center gap-3 sticky top-0 z-[60]`}
    >
      <span data-testid="env-ribbon-label">{label}</span>
      <span className="hidden sm:inline opacity-80 normal-case tracking-normal font-normal">
        {sub}
      </span>
    </div>
  );
}
